import { forwardRef } from "react";
import { type SwitchProps as SwitchPrimitiveProps } from "react-aria-components";
import { CoreToggle, type PropsWithOptionalTestID } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./ToggleV2.styled";

export type ToggleV2Props = PropsWithOptionalTestID &
  Omit<SwitchPrimitiveProps, "children"> & {
    size?: CoreToggle.Size;
  };

const ToggleV2 = forwardRef<HTMLLabelElement, ToggleV2Props>((props, ref) => {
  const { size = "default", testID = "toggle", ...otherProps } = props;

  const { tokens } = useDesignTokens();
  const { toggle: toggleTokens } = tokens;

  return (
    <S.Switch {...otherProps} ref={ref} data-testid={testID}>
      <S.ToggleOutlineWrapper $size={size} aria-hidden>
        <S.CustomToggleWrapper $size={size}>
          <S.ToggleOuter $size={size}>
            <S.TextValuesContainer>
              <S.CheckedTextValue
                component="span"
                variant={toggleTokens.text.size[size].typography.variant}
                fontFamily={toggleTokens.text.size[size].typography.fontFamily}
                $size={size}
              >
                On
              </S.CheckedTextValue>

              <S.UncheckedTextValue
                component="span"
                variant={toggleTokens.text.size[size].typography.variant}
                fontFamily={toggleTokens.text.size[size].typography.fontFamily}
                $size={size}
              >
                Off
              </S.UncheckedTextValue>
            </S.TextValuesContainer>

            <S.ToggleInner $size={size} />
          </S.ToggleOuter>
        </S.CustomToggleWrapper>
      </S.ToggleOutlineWrapper>
    </S.Switch>
  );
});

ToggleV2.displayName = "ToggleV2";

export default ToggleV2;
